export default __webpack_public_path__ + "static/media/GR00008-yoga_picture.bef9a589.svg";